export const ArrowDownIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 7.2" width={12} height={7.2} {...props}>
        <path
            d="M6.002 5.03L10.539.265a.826.826 0 011.211 0 .94.94 0 010 1.275l-5.141 5.4a.827.827 0 01-1.183.026L.249 1.545a.937.937 0 010-1.275.826.826 0 011.211 0z"
            fill="currentColor"
        />
    </svg>
);
